import {BaseFragment, BaseFragmentProps} from "../../shared/BaseFragment";
import React, {ReactElement} from "react";
import {StyledBoxColumn, StyledContainer} from "../../shared/StyledComponents";
import {AudioDataType, ShowcaseItem, ShowcaseItemType, VideoDataType} from "../types";
import {PAGE_FRAGMENT_WIDTH, PD_LG} from "../../shared/dimens";
import {AudioPlayer} from "./AudioPlayer";
import {App} from "../App";

export type ViewItemFragmentProps = BaseFragmentProps & {
  item: ShowcaseItem,
}

export class ViewItemFragment extends BaseFragment<ViewItemFragmentProps> {

  protected renderContainerContent(): React.ReactElement | null {
    return <StyledBoxColumn
      style={{flexGrow: 1, justifyContent: "center", alignItems: "center"}}>
      {this.renderItem(this.props.item)}
    </StyledBoxColumn>
  }

  private renderItem(item: ShowcaseItem): ReactElement {
    switch (item.type) {
      case ShowcaseItemType.IMAGE:
        return this.renderImageItem(item);
      case ShowcaseItemType.VIDEO:
        return this.renderVideoItem(item);
      case ShowcaseItemType.AUDIO:
        return this.renderAudioItem(item);
      case ShowcaseItemType.SCRATCH_PROJECT:
        return this.renderScratchProjectItem(item);
    }
    return null;
  }

  private renderImageItem(item: ShowcaseItem): ReactElement {
    return <img src={item.imageData?.url}
                style={{width: "100%", maxWidth: PAGE_FRAGMENT_WIDTH, aspectRatio: 4 / 3, objectFit: "contain"}}/>;
  }

  private renderAudioItem(item: ShowcaseItem): ReactElement {
    switch (item.audioData.type) {
      default:
      case AudioDataType.URL:
        return <AudioPlayer audio={App.getAppRefs().audio} item={item}/>;
    }
  }

  private renderVideoItem(item: ShowcaseItem): ReactElement {
    switch (item.videoData.type) {
      default:
      case VideoDataType.URL:
        return null;
      case VideoDataType.EMBED_YOUTUBE:
        return <div
          style={{width: "100vw", aspectRatio: 16 / 9}}
          dangerouslySetInnerHTML={{
            __html: item.videoData.url.replace(
              /(?:https:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g,
              '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>'
            )
          }}/>;
    }
  }

  private renderScratchProjectItem(item: ShowcaseItem): ReactElement {
    return <StyledContainer size={"xlg"} style={{margin: PD_LG, alignItems: "center"}}>
      <iframe src={"https://scratch.mit.edu/projects/" + item.scratchProjectData.projectId + "/embed"} width="100%"
              height="640px"
              frameBorder="0" scrolling="no" allowFullScreen></iframe>
    </StyledContainer>;
  }
}